import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function flipHorizontally(position, context) {
  var anchorAttachmentX = context.anchorAttachmentX,
      anchorOffsetX = context.anchorOffsetX,
      anchorWidth = context.anchorWidth,
      isWithinWindow = context.isWithinWindow,
      targetAttachmentX = context.targetAttachmentX,
      targetMarginInlineStart = context.targetMarginInlineStart,
      targetMarginInlineEnd = context.targetMarginInlineEnd,
      targetOffsetX = context.targetOffsetX,
      targetWidth = context.targetWidth,
      withinLeft = context.withinLeft,
      withinScrollLeft = context.withinScrollLeft,
      withinWidth = context.withinWidth;
  var withinOffset = withinLeft + withinScrollLeft;
  var offsetLeft = isWithinWindow ? withinScrollLeft : withinLeft;
  var collisionWidth = targetWidth + targetMarginInlineStart + targetMarginInlineEnd;
  var collisionPositionLeft = position.left - targetMarginInlineStart;
  var overLeft = collisionPositionLeft - offsetLeft;
  var overRight = collisionPositionLeft + collisionWidth - withinWidth - offsetLeft;
  var offset = -2 * (anchorOffsetX + targetOffsetX);
  var targetOffset;
  var anchorOffset;
  var newOverRight;
  var newOverLeft;
  var newPositionLeft = position.left;

  if (targetAttachmentX === 'left') {
    targetOffset = -targetWidth;
  } else if (targetAttachmentX === 'right') {
    targetOffset = targetWidth;
  } else {
    targetOffset = 0;
  }

  if (anchorAttachmentX === 'left') {
    anchorOffset = anchorWidth;
  } else if (anchorAttachmentX === 'right') {
    anchorOffset = -anchorWidth;
  } else {
    anchorOffset = 0;
  }

  if (overLeft < 0) {
    newOverRight = position.left + targetOffset + anchorOffset + offset + collisionWidth - withinWidth - withinOffset;

    if (newOverRight < 0 || newOverRight < Math.abs(overLeft)) {
      newPositionLeft += targetOffset + anchorOffset + offset;
    }
  } else if (overRight > 0) {
    newOverLeft = position.left + targetMarginInlineStart + targetOffset + anchorOffset + offset - withinOffset;

    if (newOverLeft > 0 || Math.abs(newOverLeft) < overRight) {
      newPositionLeft += targetOffset + anchorOffset + offset;
    }
  }

  return _objectSpread(_objectSpread({}, position), {}, {
    left: newPositionLeft
  });
}